import { ApiClient } from "@/shared/services/api-client";
import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { 
  ResetUserPassPostRequestModel,
  ResetUserPassPostResponseModel,
  ResetUserPassPutRequestModel,
  ResetUserPassPutResponseModel,
} from "@/features/user/services/user-model";

export class ResetUserPassApi {
  /**
   * 利用者パスワードリセットメール送信API
   */
  public postSendResetUserPassMail = async (
    params: ResetUserPassPostRequestModel
  ): Promise<ResetUserPassPostResponseModel> => {
    const path = `/api/users/resetpw`

    const res = await ApiClient.instance.post<ResetUserPassPostResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };

  /**
   * 利用者パスワードリセットAPI
   */
  public putResetUserPass = async (
    params: ResetUserPassPutRequestModel
  ): Promise<ResetUserPassPutResponseModel> => {
    const path = `/api/users/resetpw`

    const res = await ApiClient.instance.put<ResetUserPassPutResponseModel>({
      path: path,
      params: params as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
